// extracted by mini-css-extract-plugin
module.exports = {"MostReadFeed":"MostReadFeed_MostReadFeed__2_3XG","title":"MostReadFeed_title__2o0jA"};